module.exports = __webpack_public_path__ + "img/tick.0bf6d709.svg";